import { ContentfulPageProps } from "../types/vino-data-types";
import { Layout } from "../components/layout";
import { PageHeader } from "../components/page-header";
import { PageFooter } from "../components/page-footer";
import PageSection from "../component-factory/page-section";
import * as React from "react";
import SEO from "../components/seo/seo";
import SearchProvider from "../contexts/search/provider";

const ContentfulPage: React.FC<ContentfulPageProps> = ({
  pageContext,
}): JSX.Element => {
  const { id, page, pagePath } = pageContext;
  const {
    title,
    pageSections,
    noIndex,
    seoTitle,
    seoDescription,
    route,
  } = page;

  return (
    <Layout
      pathname={pagePath}
      bgImage={page?.backgroundImage?.url}
      isWhiskymofo={route?.path?.includes("whiskymofo")}
      footerLayout={page?.footerLayout}
    >
      <SEO
        title={seoTitle || title}
        description={seoDescription}
        type={"page"}
        pathname={pagePath}
        robots={noIndex ? "noindex, nofollow" : "index, follow"}
      />
      <SearchProvider>
        <PageHeader {...page} pagePath={pagePath} />
        {pageSections.map((section, index) => {
          return PageSection.create({ ...section, pageId: id }, index);
        })}
      </SearchProvider>
    </Layout>
  );
};

export default ContentfulPage;
